export default "__VITE_ASSET__e73f8f5a__"